module.exports = __webpack_public_path__ + "static/media/switch.2ca035a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/switch.svg
// module id = 3638
// module chunks = 7